import * as React from "react";
import { StyleguideImgPlaceholder } from "../helpers";

type gridItemProps = {
  hasLink?: boolean;
  hasImage?: boolean;
  inner: gridItemInnerProps 
};

type gridItemInnerProps = {
  hasLink?: boolean;
  hasImage?: boolean;
  hasDate?: boolean;
  hasIntro?:boolean;
};

export function gridItem(props: gridItemProps) {
  return (
  <li className="grid__item item">
    <article className="grid__article">
      {props.hasLink ?
        <a className={`grid__inner grid__link grid__link--${props.hasImage == true ? 'image' : 'text'}`} href="/">
          {gridItemInner({hasLink: props.inner.hasLink, hasDate: props.inner.hasDate, hasImage: props.inner.hasImage, hasIntro: props.inner.hasIntro})}
        </a>
        :
        <div className="grid__inner">
          {gridItemInner({hasLink: props.inner.hasLink, hasDate: props.inner.hasDate, hasImage: props.inner.hasImage, hasIntro: props.inner.hasIntro})}
        </div>
      }
    </article>
  </li>)
}

export function gridItemInner(props: gridItemInnerProps) {
  return (
    <>
      <div className={`grid__content${props.hasImage == true ? ' grid__content--image' : ''}`}>
        <header className="grid__header">
          <h3 className="grid__title typo--m">Title of item</h3>
          {props.hasIntro &&
            <p className="grid__intro">Quam Justo Mollis</p>
          }
          {props.hasDate &&
            <time className="grid__date" date-time="27 november 2020">27 novembre 2020</time>
          }
          </header>
          {props.hasLink &&
            <svg
            className={`grid__icon${props.hasImage == true ? '' : ' grid__icon--text'}`}
            width="25px"
            height="14px"
            aria-hidden="true"
            >
              <use xlinkHref="#icon--arrow" />
            </svg>
          }
      </div>
      {props.hasImage &&
        <div className="grid__visual">
          <img className="grid__image" src={StyleguideImgPlaceholder({ shape: { width: 440, height: 255, radius: '0', bgColor: '#9CD1C2' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })} width="440" height="255" alt="" />
        </div>
      }
    </>
  )
}



// WEBPACK FOOTER //
// ./Client/styleguide/components/object/gridItem.tsx